function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Radio, notification } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var AddConclusion = function AddConclusion(_ref) {
  var candidat = _ref.candidat,
      handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      conclusionItems = _useState4[0],
      setConclusionItems = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      formError = _useState6[0],
      setFormError = _useState6[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var conclusionItemsVa = [{
    value: 1,
    label: "Apte au poste de travail occupé"
  }, {
    value: 2,
    label: "Apte au poste de travail occupé aménagement"
  }, {
    value: 3,
    label: "Apte au poste de travail occupé avec restriction"
  }, {
    value: 7,
    label: "Apte au poste occupé sous reserve d'une consultation"
  }, {
    value: 4,
    label: "Inapte temporaire au poste de travail occupé"
  }, {
    value: 5,
    label: "Inapte définitif au poste de travail occupé avec reclassement"
  }, {
    value: 6,
    label: "Inapte définitif"
  }];
  var conclusionItemsPe = [{
    value: 8,
    label: "Apte au poste  de travail souhaité"
  }, {
    value: 9,
    label: "Apte au poste de travail souhaité aménagement"
  }, {
    value: 10,
    label: "Apte au poste de travail souhaité avec restriction"
  }, {
    value: 11,
    label: "Apte au poste souhaité sous reserve d'une consultation"
  }, {
    value: 12,
    label: "Inapte temporaire au poste de travail souhaité"
  }, {
    value: 13,
    label: "Inapte définitif au poste de travail souhaité avec reclassement"
  }, {
    value: 14,
    label: "Inapte définitif"
  }];

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("motif", candidat.reason);
    formData.append("conclusion", values.conclusion);
    formData.append("comment", values.comment);
    formData.append('customer_id', candidat.id);
    formData.append("prevention_tips", values.prevention_tips);
    formData.append("mr_general_state", values.mr_general_state);
    formData.append("mr_conclusion", values.mr_conclusion);
    formData.append("mr_recommandation", values.mr_recommandation);
    formData.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addconclusion', formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      comment: "NEANT",
      prevention_tips: "",
      mr_recommandation: "",
      mr_conclusion: "Patient(e) vu(e) ce jour avec un bon état de santé.",
      mr_general_state: "Etat général satisfaisant"
    });
    if (candidat.motif == 0) setConclusionItems(conclusionItemsVa);
    if (candidat.motif == 1) setConclusionItems(conclusionItemsPe);
    if (candidat.motif != 0 && candidat.motif != 1) setConclusionItems(conclusionItemsVa);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        padding: "10px",
        background: "#FFDE09",
        borderRadius: "0px 7px 7px 7px",
        color: "#FFFFFF"
      },
      children: /*#__PURE__*/_jsxs(Descriptions, {
        title: /*#__PURE__*/_jsx("b", {
          children: "INFOS CANDIDATS"
        }),
        column: 2,
        children: [/*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Nom complet"
          }),
          children: candidat.name
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "T\xE9l\xE9phone"
          }),
          children: candidat.mobile_first
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Poste"
          }),
          children: candidat.job
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Nationalit\xE9"
          }),
          children: candidat.nationality
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "SOCIETE"
          }),
          children: candidat.company.label
        })]
      })
    }), /*#__PURE__*/_jsx(Divider, {
      children: "DONNEES DE CONCLUSION"
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 10,
          sm: 11,
          children: /*#__PURE__*/_jsxs(Form, {
            layout: "vertical",
            form: form,
            onFinish: onFinish,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "conclusion",
              label: "Aptitude",
              rules: [{
                required: true,
                message: "Ce champ est obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                options: candidat.reason == 0 || candidat.reason == 2 ? conclusionItemsVa : conclusionItemsPe,
                buttonStyle: "solid",
                optionType: "button"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "comment",
              label: "Pr\xE9cision",
              children: /*#__PURE__*/_jsx(Input, {})
            }), /*#__PURE__*/_jsx(Divider, {
              children: "DONNEES DU RAPPORT MEDICAL"
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "mr_general_state",
              label: "Etat g\xE9n\xE9ral",
              children: /*#__PURE__*/_jsx(Input, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "mr_conclusion",
              label: "Conclusion",
              children: /*#__PURE__*/_jsx(TextArea, {
                autoSize: true
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "mr_recommandation",
              label: "Recommandations",
              children: /*#__PURE__*/_jsx(TextArea, {
                autoSize: true
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                type: "primary",
                htmlType: "submit",
                children: /*#__PURE__*/_jsx("b", {
                  children: "VALIDER"
                })
              })
            })]
          })
        })
      })
    })]
  });
};

export default AddConclusion;